import React from 'react';
import './HeroCard.css';
import Button from '../button/Button';

function HeroCard({ title, description, statistics, buttonText, onButtonClick,handMobileSrc, causeMobileSrc,className}) {
  return (
    <div className='heroCard'>
      <div className='heroLeft'>
        <div className='heroText'>
          <div className={className.heroTextTitle}>{title}</div>
          <div className={className.heroTextInfo}>{description}</div>
        </div>
        <div className='numbersButton'>
          <div className='causeStats'>
            {statistics.map((stat, index) => (
              <div key={index} className='causeStatsBox'>
                <div className='causeStatsFig'>{stat.value}</div>
                <div className='causeStatsText'>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <Button onClick={onButtonClick} buttonText={buttonText} className={className.customButton} arrowClassName="custom-arrow" />

      </div>
      <div className='heroRight'>
        <img className={className.handMobile} src={handMobileSrc} alt="Hand Mobile" /> 
        <img className={className.causeMobile} src={causeMobileSrc} alt="Cause Mobile" />
      </div>

      <div className='heroCardMobile'>
        <div className='heroText'>
          <div className={className.heroTextTitle}>{title}</div>
          <div className={className.heroTextInfo}>{description}</div>
        </div>
        <div className='heroRightMobile'>
        <img className={className.handMobile} src={handMobileSrc} alt="Hand Mobile" /> 
        <img className={className.causeMobile} src={causeMobileSrc} alt="Cause Mobile" />
        </div>

        <div className='dataAndButton'>
        <div className='numbersButton'>
          <div className='causeStats'>
            {statistics.map((stat, index) => (
              <div key={index} className='causeStatsBox'>
                <div className='causeStatsFig'>{stat.value}</div>
                <div className='causeStatsText'>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
        <Button onClick={onButtonClick} buttonText={buttonText} className={className.customButton} arrowClassName="custom-arrow" />
        </div>

      </div>
    </div>
  );
}

export default HeroCard;
